import { useTranslation } from "@nova/use-translation"
import classNames from "classnames"
import { ReactElement } from "react"

type TooltipProps = {
    message?: string
    children: ReactElement
    classes?: string
    clickHandler?: VoidFunction
    doubleClickHandler?: VoidFunction
    disabled?: boolean
    messageClasses?: string
    light?: boolean
}

export const Tooltip = ({
    clickHandler,
    doubleClickHandler,
    classes: containerClassOverrides,
    messageClasses: messageContainerClassOverrides,
    message,
    children,
    disabled,
    light,
}: TooltipProps) => {
    const { t } = useTranslation()
    if (disabled || !message || message === "") {
        return (
            <div
                className="flex flex-col items-center justify-center h-full"
                onClick={clickHandler}
                onDoubleClick={doubleClickHandler}
            >
                {children}
            </div>
        )
    }

    return (
        <div
            onClick={clickHandler}
            className={classNames(
                "relative flex flex-col items-center group/tooltip",
                containerClassOverrides
            )}
        >
            {children}
            <div
                className={classNames(
                    "tooltip-content absolute bottom-10 flex-col items-center hidden mb-6 group-hover/tooltip:flex group-hover/tooltip:w-40 z-[60]",
                    messageContainerClassOverrides
                )}
            >
                <span
                    className={classNames(
                        "fixed p-2 text-xs leading-none whitespace-no-wrap shadow-lg rounded-md",
                        {
                            "bg-gray-500 text-white": !light,
                            "bg-white text-black": light,
                        }
                    )}
                >
                    {t(message)}
                </span>
            </div>
        </div>
    )
}

export default Tooltip
